import clsx from 'clsx'
import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Image } from '@/src/elements/image'
import { Icon } from '@/src/elements/media/Icon'
import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'

import { REWARD_CITATION_IMAGES } from '../../../models/rewardCitation.constants'

const prayerImagePathsByName = {
  [REWARD_CITATION_IMAGES.BLOW_BUBBLE_PRAYER]: require('@/img/prayer/blow_bubble_prayer.png'),
  [REWARD_CITATION_IMAGES.FRONT_OF_PRAYER_SPACE_PRAYER]: require('@/img/prayer/front_of_prayer_space_prayer.png'),
  [REWARD_CITATION_IMAGES.RAISE_HAND_PRAYER]: require('@/img/prayer/raise_hand_prayer.png'),
  [REWARD_CITATION_IMAGES.TOGETHER_PRAYER]: require('@/img/prayer/together_prayer.png'),
  [REWARD_CITATION_IMAGES.SEND_INTENTION_PRAYER]: require('@/img/prayer/send_intention_prayer.png'),
  [REWARD_CITATION_IMAGES.JESUS_CHRIST]: require('@/img/prayer/jesus_christ.png'),
  [REWARD_CITATION_IMAGES.VIRGIN_MARY]: require('@/img/prayer/virgin_mary.png'),
}

type TPrayRewardQuoteProps = {
  content?: string
  image?: REWARD_CITATION_IMAGES
  author?: string
}

export const PrayRewardCitationBase = ({ content, image, author }: TPrayRewardQuoteProps): ReactNode => {
  const isEmpty = !content && !image && !author
  const showFigureImage = !!image && !!content
  const showDefaultImage = !!image && !content

  if (isEmpty) return null
  return (
    <View className="w-full">
      {!!image && (
        <View
          className={clsx('w-full', {
            'mb-6 h-64 sm:h-96': showDefaultImage,
            'mx-auto h-56 w-56': showFigureImage,
          })}
        >
          <Image source={prayerImagePathsByName[image]} contentFit="contain" testID={TEST_ID.REWARD.IMAGE} />
        </View>
      )}
      {!!content && (
        <View
          className={clsx('flex items-center justify-center gap-1 px-4', {
            'py-16': !showFigureImage,
            '-mt-4': showFigureImage,
          })}
        >
          <Icon
            name={ICON.QUOTE_START}
            size={showFigureImage ? 'xl' : '3xl'}
            className={clsx('self-start text-primary-icon-contrast-lower', {
              'text-primary-text-contrast-low': showFigureImage,
            })}
          />
          <Typography size="lg" colors="primary" bold center italic contrast="default" testID={TEST_ID.REWARD.QUOTE}>
            {content}
          </Typography>
          <Icon
            name={ICON.QUOTE_END}
            size={showFigureImage ? 'xl' : '3xl'}
            className={clsx('self-end text-primary-icon-contrast-lower', {
              'text-primary-text-contrast-low': showFigureImage,
            })}
          />
          <Typography size="md" colors="primary" bold center italic contrast="low" testID={TEST_ID.REWARD.AUTHOR}>
            {author}
          </Typography>
        </View>
      )}
    </View>
  )
}
